import { render, staticRenderFns } from "./quoteAnimateNumber.vue?vue&type=template&id=06043c03"
import script from "./quoteAnimateNumber.vue?vue&type=script&lang=js"
export * from "./quoteAnimateNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports